<template >
  <div class="mainbody">
    <div class="tableHead">
      <div class="box">
        <p class="title1">未填写资料</p>
        <p class="title2">{{ notEditInfoCount }}个校友</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">本周识别接口调用</p>
        <p class="title2">{{ faceApiUseCount }}次</p>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <p class="title1">本周自动完成认证</p>
        <p class="title2">{{ authenticationSuccessCount }}个校友</p>
      </div>
    </div>
    <div class="tableInfo">
      <el-table
        :data="data_list"
        @row-click="toDetails"
        @filter-change="filterChange"
      >
        <el-table-column prop="id" label="ID" min-width="1"></el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="1"
        ></el-table-column>
        <el-table-column
          prop="id_card_number"
          label="身份证号"
          min-width="2"
        ></el-table-column>
        <el-table-column
          prop="member_type"
          label="会员类型"
          min-width="1"
          :filters="optionsMemberType"
          filter-placement="bottom-end"
          column-key="filterMembertype"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          min-width="2"
        ></el-table-column>
        <el-table-column
          prop="resultStr"
          label="认证状态"
          min-width="1"
          :filters="optionsExamine"
          filter-placement="bottom-end"
          column-key="filterResult"
        ></el-table-column>
      </el-table>
      <el-pagination
        :key="elementui_page_key"
        class="elPagination"
        background
        layout="prev, pager, next"
        :page-size="pageMaxSize"
        :page-count="pageCount"
        :current-page="currentPage"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [], //数据列表
      optionsExamine: Constant.options_attestation,
      optionsMemberType: Constant.options_face_member_type,
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      notEditInfoCount: 0,
      faceApiUseCount: 0,
      authenticationSuccessCount: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList: function () {
      console.log(this.screen_member_type);
      this.$api
        .faceAuthenticationList({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,
          screen_result: this.screen_result,
          screen_member_type: this.screen_member_type,
        })
        .then(({ data }) => {
          this.notEditInfoCount = data.Data.notEditInfoCount;
          this.faceApiUseCount = data.Data.faceApiUseCount;
          this.authenticationSuccessCount =
            data.Data.authenticationSuccessCount;

          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getList();
          }
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          this.data_list.forEach((info) => {
            this.optionsExamine.forEach((examin) => {
              if (info.result == parseInt(examin.value)) {
                info.resultStr = examin.text;
              }
            });
            this.optionsMemberType.forEach((memb) => {
              if (info.member_type == memb.value) {
                info.memberTypeStr = memb.text;
              }
            });
            info.createTime = Utils.dateFormat(info.create_time * 1000);
            info.member_type = Constant.formar_member_type[info.member_type];
          });
        })
        .catch(({ error }) => {});
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getList();
    },
    // 过滤
    filterChange(filters) {
      this.screen_result = StrUtils.getStr4List1(filters.filterResult);
      if (this.screen_result == "") this.screen_result = undefined;
      this.screen_member_type = StrUtils.getStr4List1(filters.filterMembertype);
      if (this.screen_member_type == "") this.screen_member_type = undefined;
      this.getList();
    },
    // 查看详情
    toDetails(row, column, event) {
      if (row.result == 3) return;
      this.$router.push({
        path: "/wxapp/authentication_face_details",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  // background-color: #ffffff;
  border-radius: 5px;
  // padding-bottom: 58px;
}
.mainbody .tableHead {
  background-color: #ffffff;
  box-sizing: border-box;
  margin-bottom: 16px;
  overflow: hidden; /*溢出的部分隐藏*/
}
.mainbody .tableHead .box {
  padding: 24px;
  width: 29%;
  height: 50px;
  float: left;
  text-align: center;
}
.mainbody .tableHead .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}
.mainbody .tableHead .title2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
}
.mainbody .tableHead .aLine {
  float: left;
  background-color: #e9e9e9;
  width: 1px;
  height: 56px;
  margin-top: 25px;
}
.mainbody .tableInfo {
  background-color: #ffffff;
  box-sizing: border-box;
  // margin-top: 24px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  overflow: hidden; /*溢出的部分隐藏*/
}
</style>


// WEBPACK FOOTER //
// src/components/authentication/faceAuthenticationList.vue